import localeMap from '@i18n/localeToMoment.json';
import { routeExposedLocales } from '@spotify-internal/s4mp-shared';

export const DEFAULT_LOCALE = 'en';

let language = DEFAULT_LOCALE;
const map: { [key: string]: string } = localeMap;

export function setLanguagePreference(locale?: string) {
  if (locale && routeExposedLocales.includes(locale)) {
    language = locale;
  }
}

export function getLanguagePreference() {
  return language ? (language as string) : DEFAULT_LOCALE;
}

export function getLanguageAsMomentLocale(locale: string) {
  return map[locale.toLowerCase()] || '';
}

export function getLanguagePreferenceAsMomentLocale() {
  return getLanguageAsMomentLocale(language.toLowerCase()) || DEFAULT_LOCALE;
}
